import React, { Component } from "react";
import { Container, Row, Col, CardGroup, Card, CardBlock, Button, Input, InputGroup, InputGroupAddon } from "reactstrap";

import * as Constant from '../../../constants/AppConstants';
import axios from 'axios';
import { loadProgressBar } from 'axios-progress-bar';
loadProgressBar()

class Login extends Component {
	constructor(props) {
		super(props);
		this.login = this.login.bind(this);
		this.state = {
			user_name: '',
			password: '',
			mode: Constant.MODE_LOGIN,
			isLoggedin: false,
			msg: 'You are not logged in',
			timeouterror: '',
		}

		this.generateTokenState = {
			mode: Constant.MODE_GENERATE_TOKEN,
			source: 'LiteLMS',
			timeouterror: '',
		}
	}

	componentWillUnmount() {
		clearInterval(this.timerID);
	}

	navigateToLogin() {
		this.props.history.push('/Login');
	}

	navigateToDashboard() {
		this.props.history.push('/dashboard');
	}

	login(e) {
		e.preventDefault();
		this.setState({
			msg: ''
		});
		var self = this;
		var querystring = require('querystring');

		var payload = querystring.stringify({
			mode: self.state.mode,
			user_name: self.state.user_name,
			password: self.state.password,
		})

		var generateToken = querystring.stringify({
			mode: self.generateTokenState.mode,
			source: self.generateTokenState.source,
		})

		axios({
			method: 'post',
			url: Constant.API_URL,
			headers: {
				'content-type': 'application/x-www-form-urlencoded',
			},
			withCredentials: false,
			data: generateToken,
			timeout: 30000
		}).then(function (response) {
			if (response.status == 200) {
				window.localStorage.setItem(Constant.TOKEN, response.data.token);
				axios({
					method: 'post',
					url: Constant.API_URL,
					headers: {
						'content-type': 'application/x-www-form-urlencoded',
					},
					withCredentials: false,
					data: payload,
					timeout: 30000
				}).then(function (response) {
					if (response.status == 200) {
						if (response.data.v3_check === false) {
							self.setState(prevState => ({
								msg: "Please logged in into new Partners Portal.",
								isLoggedin: false,
							}));
						} else {
							self.setState(prevState => ({
								msg: 'Successfully logged in',
								isLoggedin: true,
							}));
							window.localStorage.setItem(Constant.AUTH_TOKEN, response.data.auth_token);
							window.localStorage.setItem(Constant.IS_LOGGED_IN, true);
							window.localStorage.setItem(Constant.ORG_ID, response.data.organization_id);
							window.localStorage.setItem(Constant.INV_ACC, response.data.invoice_access);
							window.localStorage.setItem(Constant.DSA_REPORT_HEADING, response.data.dsa_report);
							self.navigateToDashboard();
						}
					} else if (response.status == 201) {
						self.setState(prevState => ({
							msg: "Username password do not match",
							isLoggedin: false,
						}));
					} else {
						self.setState(prevState => ({
							msg: "Username does not exist",
							isLoggedin: false,
						}));
					}
				}).catch(function (error) {
					if (error.code == 'ECONNABORTED') {
						self.setState({ timeouterror: 'Request timed out. Please try again after sometime' })
					} else if (error.response.status == 404) {
						self.setState(prevState => ({
							msg: "Error: Not Found",
							isLoggedin: false,
						}));
					} else if (error.response.status == 500) {
						self.setState(prevState => ({
							msg: "Internal Error. Please try again after sometime.",
							isLoggedin: false,
						}));
					}
				});
			} else {
				self.setState(prevState => ({
					msg: response.error,
					isLoggedin: false,
				}));
			}
		}).catch(function (error) {
			if (error.code == 'ECONNABORTED') {
				self.setState({ timeouterror: 'Request timed out. Please try again after sometime' })
			} else if (error.response.status == 404) {
				self.setState(prevState => ({
					msg: "Error: Not Found",
					isLoggedin: false,
				}));
			} else if (error.response.status == 500) {
				self.setState(prevState => ({
					msg: "Internal Error. Please try again after sometime.",
					isLoggedin: false,
				}));
			}
		});
	}

	render() {
		return (
			<div className="app flex-row align-items-center">
				<Container>
					<Row className="justify-content-center">
						<Col md="8">
							<CardGroup className="mb-0">
								<Card className="p-4">
									<CardBlock className="card-body">
										<h2>StashFin Partner Login</h2>
										<p className="text-muted">Sign In to your account</p>
										<form>
											<InputGroup className="mb-3">
												<InputGroupAddon style={{ height: '38px', marginTop: '5px', borderRadius: '8px', paddingLeft: '13px' }}><i className="icon-user"></i></InputGroupAddon>
												<Input type="text" placeholder="Username" onChange={(event) => this.setState({ user_name: event.target.value })} />
											</InputGroup>
											<InputGroup className="mb-4">
												<InputGroupAddon style={{ height: '38px', marginTop: '5px', borderRadius: '8px' }}><i className="icon-lock"></i></InputGroupAddon>
												<Input type="password" placeholder="Password" onChange={(event) => this.setState({ password: event.target.value })} />
											</InputGroup>
											<Row>
												<Col xs="12">
													<p style={{ color: 'red' }}>{this.state.msg}</p>
												</Col>
											</Row>
											<Row>
												<Col xs="6">
													<div style={{ color: 'red' }}>{this.state.timeouterror ? this.state.timeouterror : ''}</div>
													<Button type="submit" color="primary" className="px-4" onClick={this.login}>Login</Button>

												</Col>

											</Row>
										</form>
									</CardBlock>
								</Card>
								<Card className="text-white bg-primary py-5 d-md-down-none" style={{ width: 44 + '%' }}>
									<CardBlock className="card-body text-center">
										<div>
											<h2>StashFin Partner Program</h2>
											<p>StashFin is proud to announce an excellent partner program.
												We are looking for high quality partners to join our team and help us grow the lending market in India.
												For enquiries please email <a style={{ color: 'white' }} href="mailto: channelpartners@stashfin.com"> channelpartners@stashfin.com </a> </p>
											<Button color="primary" className="mt-3" active> <a href="mailto: channelpartners@stashfin.com"> Join StashFin Partner Program </a></Button>
										</div>
									</CardBlock>
								</Card>
							</CardGroup>
						</Col>
					</Row>
				</Container>
			</div>
		);
	}
}

export default Login;



// WEBPACK FOOTER //
// ./src/views/Pages/Login/Login.js